import script from "./FornecedorFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./FornecedorFrame.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/layoutFrames.css?vue&type=style&index=0&id=8b44cc0c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b44cc0c"]])

export default __exports__